module.exports = __webpack_public_path__ + "img/LogoTakin.4dbb5d40.png";